import 'twin.macro';
import 'styled-components/macro';

import { useNavigate } from 'react-router-dom-v5-compat';

import { MainMenu } from './MainMenu';
import { MenuItem } from './MenuItem';
import { MenuList } from './MenuList';

export interface LoggedInMenuProps {
  teamSlug?: string;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  onLogout?: () => void;
  showAdminMenuEntry?: boolean;
  showDocumentationMenuEntry?: boolean;
}

export const LoggedInMenu = ({
  teamSlug,
  shouldHideContent,
  shouldHideInspirationLibrary,
  showAdminMenuEntry,
  showDocumentationMenuEntry,
  onLogout,
}: LoggedInMenuProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <MainMenu
        title="Navigate"
        shouldHideContent={shouldHideContent}
        shouldHideInspirationLibrary={shouldHideInspirationLibrary}
        tw="sm:hidden"
        team={teamSlug}
      />

      <MenuList title="Account settings">
        <MenuItem onOpenSubmenu={() => navigate('/users/self/edit')}>Edit profile</MenuItem>
      </MenuList>

      <MenuList title="Actions">
        {showAdminMenuEntry && (
          <MenuItem>
            <a
              target="_blank"
              href={`https://instruqt.retool.com/apps/instruqt-admin?_environment=${
                window.location.hostname.endsWith('.dev') ? 'staging' : 'production'
              }`}
              rel="noreferrer"
            >
              Admin
            </a>
          </MenuItem>
        )}

        {showDocumentationMenuEntry && (
          <MenuItem onOpenSubmenu={() => window.open('https://docs.instruqt.com')}>Documentation</MenuItem>
        )}

        <MenuItem onOpenSubmenu={() => onLogout?.()}>Logout</MenuItem>
      </MenuList>
    </div>
  );
};
